import {LetrusApi} from '@letrustech/letrus-api-interfaces';
import {MappedCompetences} from 'components/ReviewSidebar';
import {fromJS} from 'immutable';
import detectMobile from 'ismobilejs';

function getTotalReviewScore(
  review?: ImmutableMap<LetrusApi.CompositionReviewDetail>,
): number {
  if (!review) {
    return 0;
  }

  return review
    .get('review_grades')
    .toJS()
    .reduce((memo, g) => {
      return memo + (g.grade_item ? g.grade_item.points : 0);
    }, 0);
}
export function getTotalReviewLevelScore(
  review: ImmutableMap<LetrusApi.CompositionReviewDetail>,
  competences: MappedCompetences[] = [],
): number {
  if (!review) {
    return 1;
  }
  if (!review.get('composition')) {
    return 1;
  }
  const totalCompenteces =
    review.getIn(['composition', 'genre', 'competences']) ||
    fromJS(competences);

  const totalReviewScore = getTotalReviewScore(review);

  const result = Math.ceil(totalReviewScore / totalCompenteces.size);

  return result === 0 ? 1 : result;
}

interface LevelDescriptionProps {
  genre: ImmutableMap<LetrusApi.Genre>;
  level: number;
  cycleType: number | undefined;
  review: ImmutableMap<LetrusApi.CompositionReviewDetail>;
}

export const getLevelDescription = ({
  genre,
  level = 0,
  cycleType,
  review,
}: LevelDescriptionProps): string => {
  const levelDescription = genre
    ?.get('levels')
    .find(
      (item: ImmutableMap<LetrusApi.ReviewGridLevel>) =>
        item.get('level') === level,
    );

  const zeroGradeReasonId = review.get('zero_grade_reason');

  if (zeroGradeReasonId && zeroGradeReasonId >= 12) {
    if (level === 1 && genre.get('review_grid_name') === 'Grade Única') {
      return review.get('general_comments');
    }
  }

  if (levelDescription) {
    if (cycleType === 2) {
      return levelDescription.get('description_student');
    }
    return levelDescription.get('description_student_cycle_one');
  }

  return '';
};

export const getCompetences = (
  genre: ImmutableMap<LetrusApi.Genre>,
  review: ImmutableMap<LetrusApi.CompositionReviewDetail>,
): MappedCompetences[] => {
  const competences = genre.get('competences');

  const getDisplayPoints = (grade, maxScore: number) => {
    const displayPoints = grade
      ? grade.getIn(['grade_item', 'display_points'])
      : 0;
    if (parseInt(displayPoints, 10)) {
      return `${displayPoints} de ${maxScore} pts`;
    }
    return displayPoints;
  };

  return competences.map(
    (competence: ImmutableMap<LetrusApi.CompositionCompetence>) => {
      const grade = review
        .get('review_grades')
        .find((reviewGrade: ImmutableMap<LetrusApi.ReviewCompetenceGrade>) => {
          return reviewGrade.get('competence') === competence.get('id');
        });

      const comments = grade && grade.get('comments');

      const points = grade ? grade.getIn(['grade_item', 'points']) : 0;

      const maxScore = competence.get('max_value_range');

      return {
        name: competence.get('name'),
        id: competence.get('id'),
        level: points,
        likeInfo: grade?.get('like_info'),
        gradeId: grade?.get('id'),
        scoreDisplay: getDisplayPoints(grade, maxScore),
        score: points,
        maxScore,
        comments,
        studentCompetenceDescription: competence.get('description_student'),
        studentCompetenceDescriptionCycleOne: competence.get(
          'description_student_cycle_one',
        ),
        description: competence.get('description'),
        standards: grade.getIn(['grade_item', 'description_student']),
      };
    },
  );
};

export const getAchievementsSize = (): number => {
  const isMobile = detectMobile();

  if (isMobile) {
    return 50;
  }
  return 70;
};
